import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Nav, Tab, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import UserManagement from './UserManagement';
import TemplateManagement from './TemplateManagement';
import SourceManagement from './SourceManagement';
import './AdminDashboard.css';

const AdminDashboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState('users');
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      navigate('/admin/login');
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUsername');
    navigate('/admin/login');
  };

  return (
    <div className="admin-dashboard">
      <Container fluid className="py-4">
        <Row className="mb-4">
          <Col>
            <div className="admin-header">
              <div className="d-flex justify-content-between align-items-center">
                <h1>Admin Dashboard</h1>
                <div className="d-flex align-items-center gap-3">
                  <Button variant="outline-danger" size="sm" onClick={handleLogout} className="btn-logout">
                    Logout
                  </Button>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k || 'users')}>
          <Row className="mb-4">
            <Col>
              <Nav variant="tabs" className="admin-nav-tabs">
                <Nav.Item>
                  <Nav.Link eventKey="users">
                    Users
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="templates">
                    Templates
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="sources">
                    Sources
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="admin-content">
                <Tab.Content>
                  <Tab.Pane eventKey="users">
                    <UserManagement />
                  </Tab.Pane>
                  <Tab.Pane eventKey="templates">
                    <TemplateManagement />
                  </Tab.Pane>
                  <Tab.Pane eventKey="sources">
                    <SourceManagement />
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </Col>
          </Row>
        </Tab.Container>
      </Container>
    </div>
  );
};

export default AdminDashboard;